export const JsonParse = function(data){
    if(typeof data !== 'object')
        return;

    data = JSON.stringify(data);
    return JSON.parse(data);  
}